import { Directive, Input, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneValidator]'
})
export class PhoneValidatorDirective implements OnChanges {
  @Input() countryCode: string = '';

  constructor(private ngControl: NgControl) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['countryCode']) {
      this.validatePhoneNumber(this.ngControl.control?.value);
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInputChange(phoneNumber: string) {
    this.validatePhoneNumber(phoneNumber);
  }

  private validatePhoneNumber(phoneNumber: string) {
    let isValid = true;
    if(phoneNumber){
      switch (this.countryCode) {
        case '+1': // US & Canada
          isValid = /^\d{10}$/.test(phoneNumber); // 10 digits
          break;
        case '+44': // United Kingdom
          isValid = /^(7[0-9]{9}|[1-6][0-9]{8})$/.test(phoneNumber); // 10 digits
          break;
        case '+61': // Australia
          isValid = /^04\d{8}$/.test(phoneNumber); // 10 digits
          break;
        case '+91': // India
          isValid = /^\d{10}$/.test(phoneNumber); // 10 digits
          break;
        case '+49': // Germany
          isValid = /^(0\d{1,5}\d{1,10})$/.test(phoneNumber); // Varies
          break;
          case '+33': // France
          // Validating 10 digits format (can be with or without spaces)
          isValid = /^(0[1-9]\d{8}|(?:\+33|0)([1-9]\d{8}))$/.test(phoneNumber); // 10 digits
          break;
        case '+81': // Japan
          isValid = /^(090|080|070)\d{8}$/.test(phoneNumber); // 10 or 11 digits
          break;
        case '+55': // Brazil
          isValid = /^(\(?\d{2}\)?\s?\d{4,5}-?\d{4})$/.test(phoneNumber); // 10 or 11 digits
          break;
        case '+27': // South Africa
          isValid = /^(0[1-9]\d{9})$/.test(phoneNumber); // 10 digits
          break;
        case '+7': // Russia
          isValid = /^9\d{9}$/.test(phoneNumber); // 10 digits
          break;
        case '+52': // Mexico
          isValid = /^(\d{10})$/.test(phoneNumber); // 10 digits
          break;
        case '+39': // Italy
          isValid = /^0\d{2,3}\d{6,7}$/.test(phoneNumber); // Varies
          break;
        case '+31': // Netherlands
          isValid = /^(0[1-9]\d{8})$/.test(phoneNumber); // 9 digits
          break;
        case '+34': // Spain
          isValid = /^(6|7)\d{8}$/.test(phoneNumber); // 9 digits
          break;
        case '+64': // New Zealand
          isValid = /^0[23478]\d{8}$/.test(phoneNumber); // 9 digits
          break;
        case '+41': // Switzerland
          isValid = /^\d{9,10}$/.test(phoneNumber);  // Allow numbers starting with 0–9, total length 9 or 10 digits
          break;
        default:
          isValid = false; // If country code is not recognized
      }
  
      this.ngControl.control?.setErrors(isValid ? null : { invalidPhoneNumber: true });
    }
    else{
      this.ngControl.control?.setErrors(isValid ? null : { invalidPhoneNumber: false });
    }
   
}

}
